import {
  ButtonHTMLAttributes,
  ComponentProps,
  forwardRef,
  MouseEvent,
} from 'react';
import { Link } from 'react-router-dom';
import isNil from 'lodash/isNil';
import { useAnalytics } from '../../utils/analytics/useAnalytics';
import { buttonClicked } from '../../utils/analytics/events/button/events';
import { IButtonAnalyticsProps } from './types';

type IAnalyticsLinkProps = ComponentProps<typeof Link> & IButtonAnalyticsProps;

export const AnalyticsLink = forwardRef<HTMLAnchorElement, IAnalyticsLinkProps>(
  ({ trackContext, trackAction, onClick, ...props }, ref) => {
    const { track } = useAnalytics();

    let handleOnClick: typeof onClick;
    if (!isNil(trackContext) && !isNil(trackAction)) {
      handleOnClick = (event) => {
        track(buttonClicked({ context: trackContext, action: trackAction }));
        return onClick?.(event);
      };
    } else {
      handleOnClick = onClick;
    }

    return <Link ref={ref} {...props} onClick={handleOnClick} />;
  },
);

type IAnalyticsHtmlButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  IButtonAnalyticsProps;

export const AnalyticsHtmlButton = forwardRef<
  HTMLButtonElement,
  IAnalyticsHtmlButtonProps
>(({ trackContext, trackAction, onClick, ...props }, ref) => {
  const { track } = useAnalytics();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (!isNil(trackContext) && !isNil(trackAction)) {
      track(buttonClicked({ context: trackContext, action: trackAction }));
    }

    onClick?.(event);
  };

  return <button ref={ref} {...props} onClick={handleClick} />;
});
